var map = {
	"./Component16–2.png": 19565,
	"./android.png": 9039,
	"./aws-ecs_fargate.png": 16794,
	"./aws-elasticache.png": 43274,
	"./aws-elb.png": 34801,
	"./aws-lambda.png": 88025,
	"./aws-rds.png": 59239,
	"./aws.png": 67673,
	"./azure.png": 60819,
	"./background.png": 41964,
	"./gcp.png": 59108,
	"./ios.png": 71449,
	"./logo.png": 65549,
	"./rakuten1.png": 91661,
	"./rakutenBrand.png": 83219
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21382;